import { match } from 'ts-pattern';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { LynxSedonaGrillVariant } from '../__generated/model/index.js';
export const grillExpressions = implementCustomExpressions({
    LynxSedonaGrillW30: {
        $grillObjectName: (s)=>{
            return match(s.variant).with(LynxSedonaGrillVariant.ProSear_SsBurner1, ()=>'GRILL_LYNX_SEDONA_L501PS').with(LynxSedonaGrillVariant.ProSear_SsBurner1_Rotisserie, ()=>'GRILL_LYNX_SEDONA_L501PSR').otherwise(()=>'GRILL_LYNX_SEDONA_L501PS');
        }
    },
    LynxSedonaGrillW36: {
        $grillObjectName: (s)=>{
            return match(s.variant).with(LynxSedonaGrillVariant.SsBurner3, LynxSedonaGrillVariant.ProSear_SsBurner2, ()=>'GRILL_LYNX_SEDONA_L601PS').with(LynxSedonaGrillVariant.SsBurner3_Rotisserie, LynxSedonaGrillVariant.ProSear_SsBurner2_Rotisserie, ()=>'GRILL_LYNX_SEDONA_L601PSR').otherwise(()=>'GRILL_LYNX_SEDONA_L601PS');
        }
    },
    LynxSedonaGrillW42: {
        $grillObjectName: (s)=>{
            return match(s.variant).with(LynxSedonaGrillVariant.SsBurner3, LynxSedonaGrillVariant.ProSear_SsBurner2, ()=>'GRILL_LYNX_SEDONA_L701PS').with(LynxSedonaGrillVariant.SsBurner3_Rotisserie, LynxSedonaGrillVariant.ProSear_SsBurner2_Rotisserie, ()=>'GRILL_LYNX_SEDONA_L701PSR').otherwise(()=>'GRILL_LYNX_SEDONA_L701PS');
        }
    }
});

//# sourceMappingURL=grills.js.map